<template>
  <div>
    <div
      v-if="checkComponent"
      :class="{
        'd-md-block': MenumobileHeader,
        'help-header': ProfilemobileHeader,
        'help-header d-none d-sm-block': trackOrderHeaderHide,
      }"
    >
      <fixed-header
        :class="{
          'header-fixed': fixedHeader && docheight + 300 > windowHeight,
        }"
      >
        <header
          :class="{ profile: $route.name && $route.name.includes('mobile') }"
        >
          <div class="main-section">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="header-section">
                    <!-- brand logo -->
                    <Logo v-if="customizationLocal.topbar_logo_position"></Logo>
                    <!-- header left part -->
                    <div class="menu-left">
                      <!-- navbar start-->
                      <Menu></Menu>
                    </div>
                    <Logo
                      v-if="!customizationLocal.topbar_logo_position"
                      :class="{
                        'center-logo': !customizationLocal.topbar_logo_position,
                      }"
                    ></Logo>
                    <!-- header right part-->
                    <ul class="menu-right">
                      <LanguagePicker></LanguagePicker>
                      <li
                        class="cart-section"
                        @click="openCartSidebar()"
                        v-if="!classicHeader"
                        id="cart-section"
                      >
                        <button class="btn btn-solid" id="btn-cart">
                          {{ _T('Cart') }}
                          <svg width="24" height="24" fill="none">
                            <use xlink:href="#cart" />
                          </svg>
                          <span class="count">{{ cart_items_count }}</span>
                        </button>
                      </li>
                      <NotLoggedInNav v-if="!is_customer_logged_in" />
                      <LoggedInNav v-else />
                      <li class="notification-bar">
                        <a href="javascript:void(0)">
                          <img
                            src="/images/svg/notification.svg"
                            class="img-fluid"
                            alt
                          />
                        </a>
                      </li>
                      <Location v-if="!classicHeader"></Location>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </fixed-header>
      <CartSidebar :openCart="openCart" />
      <MobileOption v-if="!HideMobileOPtion"></MobileOption>

      <login />
      <register />
      <forgot-password />
      <loader v-show="processInProgress('route-change')" />
    </div>
  </div>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import { mapGetters } from 'vuex'
import Windowsize from '@/mixins/Windowsize'
import NotLoggedInNav from './NotLoggedInNav'
import LoggedInNav from './LoggedInNav'
import LanguagePicker from './LanguagePicker'
import CartSidebar from './CartSidebar'
//import Topbar from './Topbar'
import Location from './Location'
import Logo from './Logo'
import Menu from './Menu'
import MobileOption from './MobileOptions'

import Register from '@/components/Register/Register'
import Login from '@/components/Login/Login'
import ForgotPassword from '@/components/Login/ForgotPassword'
import Loader from '@/components/Elements/Loader.vue'

export default {
  name: 'NavBar',
  mixins: [Windowsize],
  components: {
    LoggedInNav,
    NotLoggedInNav,
    LanguagePicker,
    CartSidebar,
    //Topbar,
    Location,
    Logo,
    Menu,
    FixedHeader,
    MobileOption,
    Register,
    Login,
    ForgotPassword,
    Loader,
  },
  data() {
    return {
      openprofileDropdown: false,
      openCart: false,
      docheight: document.body.offsetHeight,
      fixedheader: [
        'goorder_store_page',
        'home',
        'goorder_store_page_category',
        'brand_store_page_category',
        'brand_store_page',
        'offers',
      ],
      headerHide: ['login', 'register', 'forgot_password', 'help'],
      mobileheaderHide: [
        'goorder_store_page',
        'brand_store_page',
        'goorder_checkout',
        'brand_checkout',
        'goorder_cart',
        'brand_cart',
        'goorder_track-order',
        'brand_track-order',
        'goorder_store_page_category',
        'brand_store_page_category',
        'profile.saved-cards',
        'profile.wallet',
        'profile.addresses',
        'profile.order-history',
        'profile.order',
      ],
      mobileheaderOrderHide: [],
      profileheaderHide: [
        'profile.personal-info',
        'profile.ongoing-orders',
        'profile.scheduled-orders',
        'profile.history',
      ],
      classicheader: ['faq'],
      mobileOptions: [
        'faq',
        'goorder_checkout',
        'goorder_cart',
        'brand_cart',
        'brand_checkout',
        'goorder_mobile_checkout',
        'brand_mobile_checkout',
        'brand_store_page_category',
        '404',
        'profile.wallet',
      ],
    }
  },
  methods: {
    setLanguage: function(lang) {
      this.$store.dispatch('setLanguage', lang)
      // localStorage.setItem('user_default_language', lang)
    },
    openCartSidebar: function() {
      this.$store.commit('OPEN_CART_SIDEBAR')
      document.body.classList.add('body-overlay')
    },
  },
  computed: {
    ...mapGetters([
      'is_customer_logged_in',
      'cart_items_count',
      '_T',
      'languageSupported',
      'currentLang',
      'userName',
      'userAvatar',
      'hide_header',
      'processInProgress',
      'customizationLocal',
    ]),
    fixedHeader() {
      if (
        this.$route.matched.some(({ name }) => this.fixedheader.includes(name))
      ) {
        return true
      }
      return false
    },
    HideMobileOPtion() {
      if (
        this.$route.matched.some(({ name }) =>
          this.mobileOptions.includes(name)
        )
      ) {
        return true
      }
      return false
    },
    classicHeader() {
      if (
        this.$route.matched.some(({ name }) =>
          this.classicheader.includes(name)
        )
      ) {
        return true
      }
      return false
    },
    MenumobileHeader() {
      if (
        this.$route.matched.some(({ name }) =>
          this.mobileheaderHide.includes(name)
        )
      ) {
        return true
      }
      return false
    },
    trackOrderHeaderHide() {
      if (
        this.$route.matched.some(({ name }) =>
          this.mobileheaderOrderHide.includes(name)
        )
      ) {
        return true
      }
      return false
    },
    ProfilemobileHeader() {
      if (
        this.$route.matched.some(({ name }) =>
          this.profileheaderHide.includes(name)
        )
      ) {
        return true
      }
      return false
    },
    checkComponent() {
      if (
        this.$route.matched.some(({ name }) => this.headerHide.includes(name))
      ) {
        return false
      } else {
        return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.help-header {
  border-bottom: 1px solid $light-border;
}
.body-rtl {
  .login-profile {
    .language-dropdown.open {
      text-align: right;
    }
  }
  .profile-detai .profile-name {
    h6 {
      margin-left: 0.5rem;
      margin-right: unset;
    }
  }
  .profile-balance {
    svg {
      margin-right: unset;
      margin-left: 0.375rem;
    }
  }
  .header-section {
    .menu-right {
      margin-left: unset;
      margin-right: auto;
      ul {
        padding-left: unset;
        padding-right: 0;
      }
    }
  }
}
.profile {
  @include responsive(sm) {
    display: none;
  }
}
header {
  &.header-fixed {
    &.vue-fixed-header--isFixed {
      .main-section {
        position: fixed;
        width: 100vw;
        left: 0;
        background-color: $white;
        top: 0;
        // animation: smoothScroll 1s forwards;
        z-index: 4;
      }
    }
  }
  .main-section {
    padding-right: 0 !important;
    box-shadow: 0 -3px 7px 0px #888888;
    //transition: all 0.5s ease;
  }
}
@keyframes smoothScroll {
  0% {
    transform: translateY(-2.5rem);
  }
  100% {
    transform: translateY(0rem);
  }
}
.mobile-fix-option {
  display: none;
}
.header-section {
  padding: 1.375rem 0;
  display: flex;
  align-items: center;
  .menu-left {
    display: flex;
  }
  .menu-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    li {
      position: relative;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
      &:first-child {
        padding-left: 0;
        &:after {
          display: none;
        }
      }
      &:last-child {
        padding-right: 0;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        height: 1.875rem;
        width: 0.063rem;
        background-color: $light-border;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .language-select {
      position: relative;
      .select-title {
        line-height: 1.125rem;
        color: $font-color;
        text-transform: capitalize;
        font-weight: 600;
        cursor: pointer;
        margin-bottom: 0;
        font-size: 1rem;
      }
      .language-dropdown {
        position: absolute;
        top: 0.75rem;
        right: 0;
        background-color: $white;
        width: 10.625rem;
        box-shadow: 0 $px3 $px15 rgba($black, 0.1);
        padding: 0.75rem 0.313rem;
        opacity: 0;
        visibility: hidden;
        transition: all 0.5s ease;
        z-index: 1;
        li {
          display: flex;
          align-items: center;
          padding: 0.5rem 0.625rem;
          border-radius: 0.125rem;
          cursor: pointer;
          transition: all 0.5s ease;
          img,
          svg {
            width: 1.125rem;
            margin-right: 0.938rem;
          }
          &:after {
            display: none;
          }
          h4 {
            margin-bottom: 0;
            text-transform: capitalize;
            font-weight: 500;
            font-size: 1rem;
          }
          &.active {
            h4 {
              color: $color-primary;
              transition: all 0.5s ease;
              font-weight: 600;
            }
          }
          &:hover {
            background: $color-primary;
            color: $white;
            transition: all 0.5s ease;
          }
        }
        &.open {
          opacity: 1;
          visibility: visible;
          top: 1.875rem;
          transition: all 0.5s ease;
        }
      }
      &.country-select {
        .select-title {
          img {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 100%;
          }
        }
      }
    }
    .cart-section {
      position: relative;
      cursor: pointer;
      @extend %default-scroll;
      img {
        cursor: pointer;
      }
      .count {
        position: absolute;
        font-size: 0.75rem;
        line-height: 0.938rem;
        background-color: $color-primary;
        padding: 0.125rem 0.375rem;
        border-radius: 100%;
        color: $white;
        right: 0.75rem;
        top: -0.5rem;
      }
      .mini-cart {
        .cart-box {
          opacity: 0;
          visibility: hidden;
          position: absolute;
          background: $white;
          box-shadow: 0 $px8 $px30 rgba($black, 0.25);
          border-radius: 0.25rem;
          width: 23.438rem;
          z-index: 4;
          left: -5rem;
          top: 2.75rem;
          .cart-title {
            padding: 1.25rem;
            border-bottom: $px1 solid $light-border;
            h5 {
              margin-bottom: 0;
              letter-spacing: 0.005em;
              color: $font-color;
              text-transform: capitalize;
              font-weight: 600;
              span {
                font-weight: 400;
              }
            }
          }
          .cart-details {
            padding: 0 1.25rem;
            position: relative;
            max-height: 17.5rem;
            overflow: auto;
            li {
              width: 100%;
              padding: 1.25rem 0;
              border-bottom: $px1 solid $light-border;
              &:after {
                display: none;
              }
              &:last-child {
                border-bottom: none;
              }
            }
            h5 {
              font-size: 0.875rem;
              line-height: 1.063rem;
              font-weight: 600;
              margin-bottom: 0.313rem;
              text-transform: capitalize;
            }
            .inner-details {
              text-transform: capitalize;
              width: 16.875rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 0.625rem;
              li {
                padding: 0 0 0 0.5rem;
                margin-left: 0.313rem;
                position: relative;
                border-bottom: none;
                width: auto;
                &:first-child {
                  margin-left: 0;
                  &:after {
                    display: block;
                  }
                }
                &:after {
                  display: block;
                  position: absolute;
                  width: 0.25rem;
                  height: 0.25rem;
                  border-radius: 100%;
                  left: 0;
                  top: 50%;
                  transform: translateY(-50%);
                  background: $warning-color;
                }
              }
            }
            .cart-price {
              display: flex;
              align-items: center;
              margin-bottom: -0.25rem;
              h6 {
                margin-bottom: 0;
                margin-right: 0.188rem;
                text-transform: uppercase;
                line-height: 1.063rem;
                letter-spacing: 0.031rem;
                color: $color-primary;
                font-weight: 500;
                span {
                  font-weight: 600;
                }
              }
              .price-info {
                position: relative;
                img {
                  margin-bottom: 0.188rem;
                  margin-left: 0.125rem;
                  cursor: pointer;
                }
                .price-info-box {
                  position: absolute;
                  left: -0.625rem;
                  top: 1rem;
                  opacity: 0;
                  width: 15rem;
                  box-shadow: 0 3.48882px 8.72204px rgba($black, 0.1);
                  border-radius: 0.25rem;
                  background: $white;
                  padding: 0.313rem 0.5rem;
                  h6 {
                    font-size: 0.625rem;
                    font-weight: 400;
                    margin-right: 0;
                    color: $font-color;
                    text-transform: capitalize;
                    letter-spacing: 0.01em;
                    span {
                      color: $color-primary;
                    }
                  }
                }
                &:hover {
                  .price-info-box {
                    opacity: 1;
                  }
                }
              }
            }
            .cart-trash {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 2.5rem;
              height: 2.5rem;
              border-radius: 0.25rem;
              background-color: rgba(var(--color-primary-source), 0.1);
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          .cart-checkout {
            padding: 0.938rem;
            border-top: $px1 solid $light-border;
            .btn {
              text-transform: capitalize;
            }
          }
          &.open {
            opacity: 1;
            visibility: visible;
          }
        }
        .cart-design {
          position: absolute;
          top: 1.875rem;
          z-index: 5;
        }
      }
    }
    .notification-bar {
      display: none;
    }
    .header-buttons {
      display: flex;
      .btn {
        height: 2.5rem;
        width: 6.25rem;
        padding: 0;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        + .btn {
          margin-left: 0.625rem;
          margin-right: 0.625rem;
        }
      }
    }
    .login-profile {
      display: flex;
      align-items: center;
      .select-title {
        display: flex;
        align-items: center;
      }
      .language-dropdown {
        top: 2.5rem;
        li {
          a {
            h4 {
              color: $font-color;
              transition: 0.3s ease;
            }
          }
          &:hover {
            background-color: $transparent;
            a {
              h4 {
                color: $color-primary;
                transition: 0.3s ease;
              }
            }
          }
        }
        &.open {
          top: 3.125rem;
        }
      }
      .profile-img {
        margin-right: 0.75rem;
        position: relative;
        .bg-size,
        img {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 100%;
          border: $px2 solid $light-border;
        }
        &:after {
          content: '';
          position: absolute;
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 100%;
          background-color: $color-primary;
          right: 0.188rem;
          top: 0.188rem;
        }
      }
      .profile-detail {
        .profile-name {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          h6 {
            line-height: 1.188rem;
            color: $font-color;
            font-weight: 500;
            margin-bottom: 0;
            margin-right: 0.5rem;
          }
        }
        .profile-balance {
          display: flex;
          align-items: center;
          margin-top: 0.375rem;
          svg {
            margin-right: 0.375rem;
          }
          span {
            font-size: 0.75rem;
            line-height: 1.063rem;
            letter-spacing: 0.036rem;
            color: $color-primary;
            text-transform: uppercase;
            font-weight: 500;
          }
        }
      }
    }
    .location {
      cursor: pointer;
      display: flex;
      align-items: center;
      img {
        width: 2.25rem;
        height: auto;
      }
      h4 {
        font-size: 1rem;
        margin-bottom: -0.125rem;
        margin-left: 0.5rem;
        font-weight: 700;
      }
    }
  }
}
.inner-header {
  .header-section {
    .menu-right {
      .language-select {
        .language-dropdown {
          z-index: 2;
        }
      }
    }
    .menu-left {
      .navbar {
        .menu_overlay {
          z-index: 3;
        }
      }
    }
  }
}
header {
  &.vue-fixed-header--isFixed {
    .main-section {
      position: fixed;
      width: 100%;
      left: 0;
      background-color: $white;
      top: 0;
      z-index: 4;
      max-width: 100%;
      right: 0;
      margin: 0 auto;
    }
  }
}
@media (max-width: 767px) {
  .cart-section,
  .login-profile {
    display: none !important;
  }
}
@media (max-width: 575px) {
  .help-header {
    header {
      display: none;
    }
  }
}
@media (max-width: 460px) {
  .header-section {
    .menu-left {
      .brand-logo {
        margin-right: $px15;
        img {
          width: $px80;
        }
      }
    }
    .menu-right {
      li {
        padding-left: $px10;
        padding-right: $px10;
      }
      .location {
        h4 {
          font-size: $px12;
        }
      }
      .language-select {
        .select-title {
          font-size: $px12;
        }
      }
    }
  }
}
#btn-cart {
  padding-left: $px10 !important;
  padding-right: $px10 !important;
}
#cart-section {
  padding-left: $px15;
  padding-right: $px15;
}
.body-rtl {
  /*.login-profile {
    .language-dropdown.open {
      text-align: right;
    }
  }*/
  /*.profile-detail {
    .profile-name {
      h6 {
        margin-left: 0.5rem;
        margin-right: unset;
      }
    }
    .profile-balance {
      svg {
        margin-right: unset;
        margin-left: 0.375rem;
      }
    }
  }*/
  .header-section {
    .menu-right {
      margin-left: unset;
      margin-right: auto;
      //ul {
      padding-left: unset;
      padding-right: 0;
      //}
    }
  }
}
</style>
